import { useId } from 'react';
import type { CustomFieldProps } from './types';
import { Input } from '@/components/ui/input';
import { CustomFieldHelperText } from './custom-field-helper-text';
import { CustomFieldLabel } from './custom-field-label';

export function CustomTextField({
  title,
  placeholder,
  onValueChange,
  value,
  disabled,
  required,
  description,
  error,
}: CustomFieldProps) {
  const id = useId();
  return (
    <div className='not-first:*:mt-2 w-full'>
      <CustomFieldLabel required={required} htmlFor={id}>
        {title}
      </CustomFieldLabel>
      <Input
        id={id}
        value={value}
        disabled={disabled}
        onChange={(e) => onValueChange?.(e.target.value)}
        placeholder={placeholder || title}
        type='text'
      />
      <CustomFieldHelperText error={error} description={description} />
    </div>
  );
}
